import Api from '@/services/Api'

const URL = 'cat/contactos-proveedor/';

export default {
    
    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getCategorias(params) {
        const URL_CATEGORIA = 'cat/categorias-contacto/'
        return Api().get(URL_CATEGORIA, {
            params: params
        })
    },
    getOperativos(params) {
        const URL_OPERATIVOS = 'cat/tags-operativos/'
        return Api().get(URL_OPERATIVOS, {
            params: params
        })
    },
    getAction(id,action) {
        return Api().get(URL + id + "/" + action + "/")
    },
    getByCorreo(params) {
        return Api().post(URL + "obtener_por_correo/",params)
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('id' in params) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },
    asignar(params) {
        let URL_ASIGNACION = `cat/proveedores/${params.proveedor}/agregar_contacto/`;
        if ('id' in params) {
            return Api().put(URL+params.id+"/editar/", params)
        }
        return Api().post(URL_ASIGNACION, params)
    }
}